module.exports = __webpack_public_path__ + "img/phone.fcb3a59b.jpg";